import Environment from '../../Environment';
import { fetchWithAuth } from '@omni/kit/utilities/utilities';
import pluralize from 'pluralize';

const debug = require('debug')('omni:messaging:service:ImageService');

export default class ImageService {
  private static get host() {
    return Environment.imageService;
  }

  static async get(resource: string, id = '') {
    const url = this._buildUrl(resource, id);

    return fetchWithAuth(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(this._handleOneResponse)
      .catch(this._handleErrorResponse);
  }

  static async post(
    resource: string,
    endUserId: string,
    data: object,
    id = ''
  ) {
    const url = this._buildUrl(resource, id);

    const bodyData = {
      ...data,
      _embedded: {
        'end-user': {
          id: endUserId,
        },
      },
    };

    return fetchWithAuth(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    })
      .then(this._handleOneResponse)
      .catch(this._handleErrorResponse);
  }

  private static _buildUrl(resource: string, id?: string) {
    id = id ? `/${id}` : '';

    return `${this.host}/${pluralize(resource)}${id}`;
  }

  private static _handleOneResponse(response: Response) {
    if (!response.ok) return Promise.reject(response);

    return response
      .json()
      .then((data) => {
        return {
          meta: {},
          status: response.status,
          data,
        };
      })
      .catch((e) => {
        throw {
          meta: {},
          status: response.status,
          message: e.message,
        };
      });
  }

  private static _handleErrorResponse(response: Response) {
    return response.text().then((text) => {
      try {
        const json = JSON.parse(text);

        return Promise.reject({
          status: response.status,
          message: Array.isArray(json.errors) ? json.errors[0].detail : json,
        });
      } catch (e) {
        return Promise.reject({
          status: response.status,
          message: text,
        });
      }
    });
  }
}
